module.exports = __webpack_public_path__ + "img/carnage.a59a1c80.png";